import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

/* eslint-disable camelcase */
export type QueueSlot = {
  slot_key: string;
  task_type: string;
  limit: number;
  updated_at?: string;
  created_at?: string;
};
/* eslint-enable camelcase */

type QueueSlotsResponse = ListResponse<QueueSlot>;

export async function getQueueSlots(artistId: string): Promise<QueueSlot[]> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/queues/slots`;
  const response = await api.executeGetRequest<QueueSlotsResponse>(url);

  return response.data.data;
}
